import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_869414e4 from 'nuxt_plugin_sentryserver_869414e4' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_56fc8406 from 'nuxt_plugin_sentryclient_56fc8406' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_vlazyload_07f73d38 from 'nuxt_plugin_vlazyload_07f73d38' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_pluginutils_a73dc89e from 'nuxt_plugin_pluginutils_a73dc89e' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_62ecfe88 from 'nuxt_plugin_pluginrouting_62ecfe88' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_3df18433 from 'nuxt_plugin_pluginmain_3df18433' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_recaptcha_e8518d8e from 'nuxt_plugin_recaptcha_e8518d8e' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_axios_4e539fca from 'nuxt_plugin_axios_4e539fca' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_ea6829e4 from 'nuxt_plugin_moment_ea6829e4' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_common_47fd80b8 from 'nuxt_plugin_common_47fd80b8' // Source: ../plugins/common.js (mode: 'all')
import nuxt_plugin_axios_397e53b5 from 'nuxt_plugin_axios_397e53b5' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_helper_2395bfd6 from 'nuxt_plugin_helper_2395bfd6' // Source: ../plugins/helper.js (mode: 'all')
import nuxt_plugin_componentglobal_2c0d1430 from 'nuxt_plugin_componentglobal_2c0d1430' // Source: ../plugins/component-global.js (mode: 'all')
import nuxt_plugin_vuepersistedstate_58779c3e from 'nuxt_plugin_vuepersistedstate_58779c3e' // Source: ../plugins/vue-persistedstate.js (mode: 'all')
import nuxt_plugin_fontawesome_244e667e from 'nuxt_plugin_fontawesome_244e667e' // Source: ../plugins/font-awesome.js (mode: 'client')
import nuxt_plugin_swal_1c9d0cd8 from 'nuxt_plugin_swal_1c9d0cd8' // Source: ../plugins/swal.js (mode: 'client')
import nuxt_plugin_vue2googlemaps_50810e79 from 'nuxt_plugin_vue2googlemaps_50810e79' // Source: ../plugins/vue2-google-maps.js (mode: 'client')
import nuxt_plugin_vuegtag_15ca6fae from 'nuxt_plugin_vuegtag_15ca6fae' // Source: ../plugins/vue-gtag (mode: 'all')
import nuxt_plugin_sentry_82ffc378 from 'nuxt_plugin_sentry_82ffc378' // Source: ../plugins/sentry.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"KONSULTASI GAMPANG YesDok","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"hid":"title","name":"title","content":"KONSULTASI GAMPANG YesDok"},{"hid":"keywords","name":"keywords","content":"Yesdok, Konsultasi Gampang, Konsultasi Online, Konsultasi Online Dokter, Praktik Dokter, Praktik Online, Praktek Online, Konsultasi Mudah, Konsultasi Dokter, Rumah Sakit, Klinik"},{"hid":"description","name":"description","content":"Konsultasi Online Dokter - Pasien GAMPANG"},{"hid":"og:title","property":"og:title","content":"KONSULTASI GAMPANG YesDok"},{"hid":"og:description","property":"og:description","content":"Konsultasi Online Dokter - Pasien GAMPANG"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fgampang.yesdok.com"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fydbucketstorage.s3.ap-southeast-1.amazonaws.com\u002Fimg\u002Fv3\u002Fmain\u002Ffavicon.ico"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"twitter:title","name":"twitter:title","content":"KONSULTASI GAMPANG YesDok"},{"hid":"twitter:description","name":"twitter:description","content":"Konsultasi Online Dokter - Pasien GAMPANG"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fgampang.yesdok.com"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fydbucketstorage.s3.ap-southeast-1.amazonaws.com\u002Fimg\u002Fv3\u002Fmain\u002Ffavicon.ico"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fydbucketstorage.s3.ap-southeast-1.amazonaws.com\u002Fimg\u002Fv3\u002Fmain\u002Ffavicon.ico?"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_869414e4 === 'function') {
    await nuxt_plugin_sentryserver_869414e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_56fc8406 === 'function') {
    await nuxt_plugin_sentryclient_56fc8406(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_07f73d38 === 'function') {
    await nuxt_plugin_vlazyload_07f73d38(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_a73dc89e === 'function') {
    await nuxt_plugin_pluginutils_a73dc89e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_62ecfe88 === 'function') {
    await nuxt_plugin_pluginrouting_62ecfe88(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_3df18433 === 'function') {
    await nuxt_plugin_pluginmain_3df18433(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_e8518d8e === 'function') {
    await nuxt_plugin_recaptcha_e8518d8e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4e539fca === 'function') {
    await nuxt_plugin_axios_4e539fca(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_ea6829e4 === 'function') {
    await nuxt_plugin_moment_ea6829e4(app.context, inject)
  }

  if (typeof nuxt_plugin_common_47fd80b8 === 'function') {
    await nuxt_plugin_common_47fd80b8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e53b5 === 'function') {
    await nuxt_plugin_axios_397e53b5(app.context, inject)
  }

  if (typeof nuxt_plugin_helper_2395bfd6 === 'function') {
    await nuxt_plugin_helper_2395bfd6(app.context, inject)
  }

  if (typeof nuxt_plugin_componentglobal_2c0d1430 === 'function') {
    await nuxt_plugin_componentglobal_2c0d1430(app.context, inject)
  }

  if (typeof nuxt_plugin_vuepersistedstate_58779c3e === 'function') {
    await nuxt_plugin_vuepersistedstate_58779c3e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontawesome_244e667e === 'function') {
    await nuxt_plugin_fontawesome_244e667e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swal_1c9d0cd8 === 'function') {
    await nuxt_plugin_swal_1c9d0cd8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2googlemaps_50810e79 === 'function') {
    await nuxt_plugin_vue2googlemaps_50810e79(app.context, inject)
  }

  if (typeof nuxt_plugin_vuegtag_15ca6fae === 'function') {
    await nuxt_plugin_vuegtag_15ca6fae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentry_82ffc378 === 'function') {
    await nuxt_plugin_sentry_82ffc378(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
